import type { FlowTemplateFlowType } from './constants'

/** How the two kinds of collected flow read in the product. */
export const FLOW_TYPE_LABEL: Readonly<Record<FlowTemplateFlowType, string>> = {
  signup: 'Signup sequence',
  newsletter: 'Newsletter',
}
